import React from "react";
import Modal from "react-bootstrap/Modal";

function DocusignAuditHistory({ auditEvents, isOpen, hideModal }) {
  return (
    <Modal show={isOpen} animation={false}>
      <Modal.Header>
        <Modal.Title>Docusign Audit History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {auditEvents.auditEvents &&
          auditEvents.auditEvents.length > 0 &&
          auditEvents.auditEvents.map((event) => (
            <div
              className={
                event.eventFields.filter((l) => l.name === "Action")[0]
                  .value === "Resent"
                  ? "border rounded bg-warning p-2 mb-2"
                  : "border rounded bg-light p-2 mb-2"
              }
            >
              <div>
                <b>Log Time: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "logTime")[0].value
                }`}
              </div>

              <div>
                <b>Source: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "Source")[0].value
                }`}
              </div>
              <div>
                <b>User Name: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "UserName")[0]
                    .value
                }`}
              </div>
              <div>
                <b>Action: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "Action")[0].value
                }`}
              </div>
              <div>
                <b>Message: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "Message")[0].value
                }`}
              </div>
              <div>
                <b>Envelope Status: </b>
                {`${
                  event.eventFields.filter(
                    (l) => l.name === "EnvelopeStatus"
                  )[0].value
                }`}
              </div>
              <div>
                <b>Information: </b>
                {`${
                  event.eventFields.filter((l) => l.name === "Information")[0]
                    .value
                }`}
              </div>
            </div>
          ))}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-danger"
          onClick={() => {
            hideModal();
          }}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DocusignAuditHistory;
